import axios from 'axios'
import { API_URL } from 'services/config'

class AccidentService {
    getUserManual = async() => {
        const { data } = await axios.get(`${API_URL}/commons/contact-us-data`)
        const { manual } = data.data
        return manual
    }

    getInsuranceCompanies = async() => {
        const { data } = await axios.get(`${API_URL}/insurance-companies`)
        const insuranceCompanies = data.data.map(({ name: id, displayName: value}) => ({ id, value }))
        return insuranceCompanies
    }

    getAccidentTypes = async() => {
        const { data } = await axios.get(`${API_URL}/accidents/vehicle-accident-types`)
        const accidentTypes = data.data.map(({ name: id, displayName: value}) => ({ id, value }))
        return accidentTypes
    }

    getInsuredPolicies = async (identityNumber, { plate, policyNumber } = {}) => {
        const query = new URLSearchParams()

        if (identityNumber) {
            query.set('identityNumber', identityNumber)
        }

        if (plate) {
            query.set('plate', plate)
        }

        if (policyNumber) {
            query.set('policyNumber', policyNumber)
        }

        const { data } = await axios.get(`${API_URL}/accidents/options?${query.toString()}`)

        return (data.data || []).map((item) => ({
            description: item.description,
            value: item.description,
            insurance: item.insurance || null,
            policyIds: item.policyIds || [],
            accidents: item.accidents || [],
            asset: {
                description: item.description,
                insurance: item.insurance || null,
                type: item.insurance || null,
            },
        }))
    }

    getAccident = async (accident) => {
        const { identityNumber, policyId, policyIds, accidentId } = accident
        const query = new URLSearchParams()

        if (identityNumber) {
            query.set('identityNumber', identityNumber)
        }

        const isCreate = accidentId == null
        const hasPolicyIds = Array.isArray(policyIds) && policyIds.length > 0

        if (isCreate && hasPolicyIds) {
            query.set('policyIds', policyIds.join(','))
            query.set('accidentId', 'null')
        } else {
            if (policyId) {
                query.set('policyId', policyId)
            }

            query.set('accidentId', isCreate ? 'null' : String(accidentId))
        }

        return axios.get(`${API_URL}/accidents?${query.toString()}`)
    }

    saveAccident = async(accident) => {
        const res = await axios.post(`${API_URL}/accidents`, accident)
        return res
    }

    sendDocuments = async(documents) => {
        const { accidentId } = documents
        const res = await axios.post(`${API_URL}/accidents/${accidentId}/files`, documents)
        return res
    }

    addExtension = async(extension) => {
        const { accidentId } = extension
        const res = await axios.post(`${API_URL}/accidents/${accidentId}/extensions`, extension)
        return res
    }
}

export default AccidentService
